import { Permission } from '../../../common/types'
import { type AccessControlConfig } from '../../../components/AccessControl/accessControl.utils'

export const InventoryFilesAccessControl: AccessControlConfig = {
  permissions: Permission.PackagesDashboardReports,
}
